export const team_mode = {
  create_channel: "Kanal anlegen",
  share_document: "Dokument teilen",
  subscribe_channel: "Kanal abonnieren",
  manage_channels: "Kanal-Verwaltung",
  subscribers: "Abonnenten",
  settings: "Einstellungen",
  created_at: "Erstellt am",
  shared_content: "Geteilte Inhalte",
  channel_data: "Kanal-Daten",
  subscription: "Abonniert",
  subscribed_channels: "Abonnierte Kanäle",
  broadcast_channels: "Broadcast-Kanäle",
  owned_channels: "Eigene Kanäle",
  channel: "Kanal",
  joined_at: "Beigetreten am",
  date_of_joining: "Beitrittsdatum",
};
